<template>
  <span class="d-flex">
    <div class="tv-box" v-for="(number, index) in numbers" :key="index"></div>
  </span>
</template>
<script>
export default {
  name: 'DisplayEmptyTV',
  props: {
    length: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    numbers() {
      return new Array(+this.length)
    },
    img() {
      return require(`@/assets/theme/digits/n.png`)
    }
  }
}
</script>
<style lang="scss" scoped>
.tv-box {
  background-image: url('../../assets/tv-box.png') !important;
}
</style>
